import { useState } from "react";

import { ScrollView, View } from "react-native";
import { Button, Divider } from "react-native-paper";
import { useTailwind } from "tailwind-rn";

import FulfillmentOptions from "./FulfillmentOptions";
import InfoModal from "./InfoModal";
import PickupInfo from "./PickupInfo";
import ReadyForPickupInfo from "./ReadyForPickupInfo";
import LoadingView from "../../../../components/LoadingView";
import DisabledView from "../../components/DisabledView";
import InfoText from "../../components/InfoText";
import SwitchWithText from "../../components/SwitchWithText";
import useDeliveryFulfillments from "../../contexts/DeliveryFulfillmentsContext";
import {
  DeliveryFulfillmentsScreenProps,
  deliveryFulfillmentsRoutes,
} from "../../navigation/types";
import { FulfillmentDispatchType } from "../../types";

type ScreenProps = DeliveryFulfillmentsScreenProps<
  typeof deliveryFulfillmentsRoutes.automaticFulfillments
>;
export default function AutomaticFulfillmentsScreen({
  navigation,
}: ScreenProps) {
  const tailwind = useTailwind();

  const {
    automaticFulfillmentsEnabled,
    updateAutomaticFulfillmentFeatureEnabled,
  } = useDeliveryFulfillments();

  const [modalVisible, setModalVisible] = useState(false);

  const [optimisticEnabled, setOptimisticEnabled] = useState<boolean | null>(
    null
  );

  const computedEnabled = optimisticEnabled ?? automaticFulfillmentsEnabled;

  async function handleFeatureToggle(nextEnabled: boolean) {
    setOptimisticEnabled(nextEnabled);
    try {
      await updateAutomaticFulfillmentFeatureEnabled(nextEnabled);
    } finally {
      setOptimisticEnabled(null);
    }
  }

  function navigateToPickupLocation() {
    navigation.navigate(deliveryFulfillmentsRoutes.pickupLocation);
  }

  function navigateToAutomaticFulfillment(type: FulfillmentDispatchType) {
    navigation.navigate(deliveryFulfillmentsRoutes.automaticFulfillment, {
      type,
    });
  }

  const isLoading = optimisticEnabled !== null;

  return (
    <ScrollView
      contentContainerStyle={tailwind(
        `mx-4 py-4 gap-4 ${isLoading ? "flex-1" : ""}`
      )}
      bounces={false}
    >
      <InfoModal
        visible={modalVisible}
        onDismiss={() => setModalVisible(false)}
      />

      <SwitchWithText
        enabled={computedEnabled}
        onChange={handleFeatureToggle}
        title={`${
          computedEnabled ? "Desactivar" : "Activar"
        } envíos automáticos`}
        details={`Pulsa para ${
          computedEnabled ? "desactivar" : "activar"
        } el servicio de envíos coordinado por Cuanto.`}
        loading={isLoading}
      />

      <Button
        mode="text"
        onPress={() => setModalVisible(true)}
        style={tailwind("self-start")}
      >
        Ver mas info
      </Button>

      <Divider />

      {isLoading ? (
        <LoadingView />
      ) : computedEnabled ? (
        <View style={tailwind("gap-4")}>
          <InfoText
            title="Direccion de recogida"
            details="Detalla la dirección donde deseas que recojan los pedidos por enviar."
          />

          <PickupInfo navigateToPickupLocation={navigateToPickupLocation} />

          <Divider />

          <ReadyForPickupInfo />

          <Divider />

          <FulfillmentOptions
            navigateToAutomaticFulfillment={navigateToAutomaticFulfillment}
          />
        </View>
      ) : (
        <DisabledView
          icon="truck-fast"
          iconString="🚚📦"
          title="¡Activa envíos automáticos para agilizar tus envíos!"
        />
      )}
    </ScrollView>
  );
}
